import { makeStyles, tokens } from "@fluentui/react-components";

export const useEmailConversationHeaderStyles = makeStyles({
    header: {
        padding: "12px 16px",
        backgroundColor: tokens.colorNeutralBackground1,
        borderRadius: tokens.borderRadiusMedium,
    },
    subjectBlock: {
        minWidth: 0,
    },
    subjectLabel: {
        flexShrink: 0,
    },
});

export const useStyles = makeStyles({
    conversationContainer: {
        margin: "1rem",
        overflow: "hidden auto",
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacingVerticalM,
    },
    emailsContainer: {
        overflow: "hidden auto",
    },
    themeProvider: {
        height: "100%",
		backgroundColor: "transparent",
		overflow: "hidden auto",
    },
    headerThemeProvider: {
		backgroundColor: "transparent",
    },
})